import { routes } from 'apps/web/constants/routes';
import { TOP_UP_TRACKING } from 'apps/web/enums/topUpTracking';
import { trackEvent, EVENTS } from 'apps/web/utils/tracking';
import { useRouter } from 'next/router';

import { Button } from '../Button';

interface TopUpButtonProps {
  onRedirect?: (route: string) => void;
}

export default function TopUpButton({ onRedirect }: TopUpButtonProps) {
  const router = useRouter();
  const handleRedirect = () => {
    trackEvent(EVENTS.CLICK_TOPUP_LINK, {
      from: TOP_UP_TRACKING.TOP_UP_BUTTON,
    });
    if (onRedirect) {
      onRedirect(routes.PRICING);
    } else {
      router.push(routes.PRICING);
    }
  };
  return (
    <Button
      className="ml-1 h-12 rounded-full bg-blue-500 px-4 py-1 text-lg font-bold text-white shadow-lg hover:bg-blue-600"
      type="button"
      onClick={handleRedirect}
    >
      Top up
    </Button>
  );
}
